// extracted by mini-css-extract-plugin
export default {"NavbarWrapper":"Navbar_NavbarWrapper__tCeI6","menu":"Navbar_menu__0gd1I","logo":"Navbar_logo__JymAQ","userAndNotification":"Navbar_userAndNotification__secjj"};